export const MAX_SESSIONS = 13;
